import React from 'react';
import Select from './Select'
import update from 'immutability-helper';
import ReactResponsiveSelect from 'react-responsive-select';

const caretIcon = (
    <svg className="caret-icon" x="0px" y="0px" width="11.848px" height="6.338px" viewBox="351.584 2118.292 11.848 6.338">
        <g><path d="M363.311,2118.414c-0.164-0.163-0.429-0.163-0.592,0l-5.205,5.216l-5.215-5.216c-0.163-0.163-0.429-0.163-0.592,0s-0.163,0.429,0,0.592l5.501,5.501c0.082,0.082,0.184,0.123,0.296,0.123c0.103,0,0.215-0.041,0.296-0.123l5.501-5.501C363.474,2118.843,363.474,2118.577,363.311,2118.414L363.311,2118.414z"/></g>
    </svg>
);

const multiSelectOptionMarkup = (text) => (
    <div>
        <span className="checkbox">
            <svg className="checkbox-icon" x="0px" y="0px" width="12px" height="12px" viewBox="0 0 488.878 488.878">
                <g><polygon points="143.294,340.058 50.837,247.602 0,298.439 122.009,420.447 122.149,420.306 144.423,442.58 488.878,98.123 437.055,46.298 "/></g>
            </svg>
        </span>
        <span> {text}</span>
    </div>
);

function Conditions(props) {

    function handleChange(value) {
        props.onChange(value);
        //console.log('The link was clicked.');
    }
    if (props.options.length) {
        return (
            <ReactResponsiveSelect
                options={props.options}
                noSelectionLabel={'Select Relation'}
                onChange={handleChange}
                caretIcon={caretIcon}
                selectedValue={props.value}
            />
        );
    } else {
        return false;
    }
}

function CategoryList(props) {
    const cats = window.awdp_object.cats;
    let options = [];
    if (cats) {
        options.push({ text: 'Select Category', value: 'null', markup: multiSelectOptionMarkup('Select Category') })
        for (var id in cats) {
            options.push({ text: cats[id], value: id, markup: multiSelectOptionMarkup(cats[id]) })
        }
        let handleChange = (value) => {
            props.onChange(value);
        }
        let value = ((Array.isArray(props.value) && props.value.length) ? props.value : ['0']);
        return (
            <ReactResponsiveSelect
                multiselect={true}
                options={options}
                caretIcon={caretIcon}
                onChange={(value) => {
                    props.onChange(value);
                }}
                selectedValues={value}
            />
        );
    }
}

function TagList(props) {
    const tags = window.awdp_object.tags;
    let options = [];
    if (tags) { 
        options.push({ text: 'Select Tag', value: 'null', markup: multiSelectOptionMarkup('Select Tag') })
        for (var i = 0; i < tags.length; i++) {
            options.push({ text: tags[i]['name'], value: tags[i]['term_id'], markup: multiSelectOptionMarkup(tags[i]['name']) })
        }
        let handleChange = (value) => {
            props.onChange(value);
        }
        let value = ((Array.isArray(props.value) && props.value.length) ? props.value : ['0']);
        return (
            <ReactResponsiveSelect
                multiselect={true}
                options={options}
                caretIcon={caretIcon}
                onChange={(value) => {
                    props.onChange(value);
                }}
                selectedValues={value}
            />
        );
    }
}

export default class FormTest extends React.Component {

    constructor(props) {
        super(props);

        let forms = [];

        this.state = {
            data: props.rules
        };
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.rules !== this.props.rules){
            this.setState({data:nextProps.rules});
        }
    }

    handleRemove(event, i, j) {
        let item = null;
        this.setState((prevState) => ({
            data: update(this.state.data, { [i]: { rules: { $unset: [j] } } })
        }), () => {
            this.props.onChange(this.state.data)
        })
    }

    handleGroupRemove(event, i) {
        let item = null;
        this.setState((prevState) => ({
           data: update(this.state.data, { $unset: [i] })
        }), () => {
            this.props.onChange(this.state.data)
        })
    }

    confirmRemove(){

    }

    handleAdd(event, i) {
        let item = [{
            "operator": 'and',
            "rule": {
                "item": "",
                "condition": "",
                "value": ""
            }
        }];

        this.setState((prevState) => ({
             data: update(this.state.data, { [i]: { rules: { $push: item } } })
        }), () => {
            this.props.onChange(this.state.data)
        })
    }

    handleGroupAdd(event, i) {
        let item = [{
            "operator": false,
            "rules": [
                {
                    "operator": false,
                    "rule": {
                        "item": "",
                        "condition": "",
                        "value": ""
                    }
                }
            ]
        }];

        this.setState((prevState) => ({
            data: update(this.state.data, { $push: item })
        }), () => {
            this.props.onChange(this.state.data)
        })
    }

    handleValueChange(event, i, j) {
        let val = event.target.value;
        //    let data = update(this.state.data, { [i]: { rules: { [j]: { rule: { value: { $set: val } } } } }} );
        this.setState((prevState) => ({
         data: update(this.state.data, { [i]: { rules: { [j]: { rule: { value: { $set: val } } } } } })
        }), () => {
            this.props.onChange(this.state.data)
        })
    }

    handleRelationChange(value, i, j = false) {
        let val = value.value;
        if (j === false) {
            this.setState((prevState) => ({
                data: update(this.state.data, { [i]: { rules: { operator: { $set: val } } } })
            }), () => {
                this.props.onChange(this.state.data)
            })
        } else {
            this.setState((prevState) => ({
                 data: update(this.state.data, { [i]: { rules: { [j]: { operator: { $set: val } } } } })
            }), () => {
                this.props.onChange(this.state.data)
            })
        }
    }

    handleCatChange(value, i, j) {
        if (value) {
            let options = value.options.map(e => {
                return e.value;
            });
            //console.log(options);
            this.setState((prevState) => ({
                data: update(this.state.data, { [i]: { rules: { [j]: { rule: { value: { $set: options } } } } } })
            }), () => {
                this.props.onChange(this.state.data)
            })
        }
    }

    handleConditionChange(value, i, j) {
        let item = null;

        if (value) {
            let sub = '';
            this.setState((prevState) => ({
               data: update(this.state.data, { [i]: { rules: { [j]: { rule: { condition: { $set: value.value } } } } } })
            }), () => {
                this.props.onChange(this.state.data)
            })
        }
    }

    handleItemsChange(newvalue, i, j) {
        if (newvalue !== undefined) {

            //this.state.data[i].rules[j].value =  event.target.value;
            let value = newvalue.value;
            this.setState((prevState) => ({
                data: update(this.state.data, { [i]: { rules: { [j]: { rule: { item: { $set: value } } } } } })
            }), () => {
                this.props.onChange(this.state.data)
            })
        }
    }

    render() {
        let render;

        const rules_items = [
            {
                text: 'Select Item',
                value: '',
                conditions: []
            },
            {
                text: 'Category',
                value: 'product_cat',
                conditions: [
                    { text: 'IN', value: 'in', sub: { type: 'product_cat' } },
                    { text: 'NOT IN', value: 'notin', sub: { type: 'product_cat' } },
                ]
            },
            {
                text: 'Tag',
                value: 'product_tag',
                conditions: [
                    { text: 'IN', value: 'in', sub: { type: 'product_tag' } },
                    { text: 'NOT IN', value: 'notin', sub: { type: 'product_tag' } },
                ]
            }
        ];
        if (this.state.data.length) {

            render = this.state.data.map((e, i) => {
                let temp = [];
                if (e.rules.length) {
                    temp.push(e.rules.map((f, j) => {
                        if(f != null) {
                            let selected_item = rules_items.filter(option => {
                                return (option.value === f.rule.item);
                            });

                            let conditions = []
                            let value_field = false;
                            if (selected_item && selected_item.length) {
                                conditions = selected_item[0].conditions;
                            }

                            let selected_condition = conditions.filter(option => {
                                return (option.value === f.rule.condition);
                            });

                            if (selected_item.length && selected_item[0].sub) {
                                value_field = selected_item[0].sub;
                            } else if (selected_condition.length && selected_condition[0].sub) {
                                value_field = selected_condition[0].sub;
                            } else {
                                value_field = { type: 'text' };
                            }

                            let value_render = '';
                            if (selected_condition.length) {
                                if (value_field.type == 'product_cat') {
                                    value_render = (
                                        <div><CategoryList value={f.rule.value} onChange={(val) => {
                                            this.handleCatChange(val, i, j);
                                        }} /></div>

                                    );
                                } else if (value_field.type == 'product_tag') {
                                    value_render = (
                                        <div><TagList value={f.rule.value} onChange={(val) => {
                                            this.handleCatChange(val, i, j);
                                        }} /></div>

                                    );
                                }
                            }
                            let relation = '';
                            // if (j < (e.rules.length - 1) && e.rules.length > 1) {
                            //     relation = (
                            //         <div className="awdp_relation clearfix">
                            //             <ReactResponsiveSelect
                            //                 options={
                            //                     [
                            //                         { text: 'AND', value: 'and' },
                            //                         { text: 'OR', value: 'or' }
                            //                     ]
                            //                 }
                            //                 selectedValue={f.operator}
                            //                 caretIcon={caretIcon}
                            //                 onChange={(newvalue) => {
                            //                     this.handleRelationChange(newvalue, i, j)
                            //                 }}
                            //             />
                            //         </div>
                            //     )
                            // }

                            return (
                                <div className="awdp_group tax_group clearfix">
                                    <div className="awdp_repeat clearfix taxonomy_repeat">
                                        <div className="awdp_onethird">
                                        <ReactResponsiveSelect
                                            options={rules_items}
                                            noSelectionLabel={'Select Discount Mode'}
                                            selectedValue={f.rule.item}
                                            caretIcon={caretIcon}
                                            onChange={(newvalue) => {
                                                this.handleItemsChange(newvalue, i, j)
                                            }}
                                        />

                                    </div>
                                    <div className="awdp_onethird">
                                        <Conditions value={f.rule.condition} onChange={(value) => {
                                            this.handleConditionChange(value, i, j);
                                        }}

                                            options={conditions} />
                                    </div>
                                    <div className="awdp_onethird">
                                        {value_render}
                                    </div>
                                    </div>
                                    {relation}
                                    <button className="awdp_add awdp_remove" onClick={(event) => {
                                        this.handleRemove(event, i, j);
                                    }}></button>
                                </div>
                            );
                            
                            //return temp.reduce((a, b) => {a + b});
                        }
                    })) // End push
                    
                }

                let relation = '';
                if (i < (this.state.data.length - 1) && this.state.data.length > 1) {
                    relation = (
                        <ReactResponsiveSelect
                            options={
                                [
                                    { text: 'AND', value: 'and' },
                                    { text: 'OR', value: 'or' }
                                ]
                            }
                            selectedValue={e.operator}
                            caretIcon={caretIcon}
                            onChange={(newvalue) => {
                                this.handleRelationChange(newvalue, i, false)
                            }}
                        />
                    )
                }

                return (<div class="group">
                    {temp.reduce((a, b) => { return a + b })}
                    <div><button className="awdp_add" onClick={(event) => {
                        this.handleAdd(event, i);
                    }}></button></div>

                    {/* <button className="awdp_removegroup" onClick={(event) => {
                        this.handleGroupRemove(event, i);
                    }}>Group Remove</button> */} 

                    {relation}
                </div>);
            });
        }

        return (
            <div>
                {render}
                { this.state.data.length == 0 ? 
                    <button className="awdp_addgroup" onClick={(event) => {
                        this.handleGroupAdd(event);
                    }}>Add Relations</button>
                : '' }
            </div>
        );
    }
}